import { useCallback, useMemo } from 'react';

import { useGraphql } from '../graphql';

// The writes a questionnaire makes, each a single GraphQL mutation that
// settles with the attempt's id.
export function useAttemptChanges() {
  const graphql = useGraphql();

  // Opens the assignment's draft, or finds the one already under way.
  const start = useCallback(function(assignmentId) {
    return graphql({
      document: 'mutation Start($assignmentId: ID!) { startAttempt(assignmentId: $assignmentId) { id } }',
      variables: { assignmentId }
    }).then(function(data) {
      return data.startAttempt.id;
    });
  }, [ graphql ]);

  const saveAnswer = useCallback(function({ attemptId, position, value }) {
    return graphql({
      document: 'mutation Answer($attemptId: ID!, $position: Int!, $value: Int!) { saveAnswer(attemptId: $attemptId, position: $position, value: $value) { id } }',
      variables: { attemptId, position, value }
    });
  }, [ graphql ]);

  const submit = useCallback(function(attemptId) {
    return graphql({
      document: 'mutation Submit($attemptId: ID!) { submitAttempt(attemptId: $attemptId) { id } }',
      variables: { attemptId }
    });
  }, [ graphql ]);

  return useMemo(function() {
    return { start, saveAnswer, submit };
  }, [ start, saveAnswer, submit ]);
}
